<template>
    <router-view :key="$route.path"></router-view>
</template>

<script>
    export default {
        name:'ChangePw'
    }
</script>

<style scoped>

</style>